var _style, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _rect8, _path3, _polygon, _path4, _path5, _polygon2, _path6, _path7, _path8, _circle4, _path9, _path10, _polygon3, _path11, _polygon4, _polygon5, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b4e9d833-dfac-4889-b0f2-073e524f4cae",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 773.1 610.8",
    style: {
      enableBackground: "new 0 0 773.1 610.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6E6E6;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#6C63FF;}\n\t.st3{fill:#F2F2F2;}\n\t.st4{fill:#9F616A;}\n\t.st5{fill:#3F3D56;}\n\t.st6{fill:#2F2E41;}\n\t.st7{fill:#CBCBCB;}\n\t.st8{opacity:0.1;enable-background:new    ;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "e81a7c33-c795-457d-8abc-c4a3c260cd56",
    x: 309.5,
    y: 12.7,
    className: "st0",
    width: 463.6,
    height: 220
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "be98c830-918a-42d1-b1b0-0085d5874e90",
    x: 322.7,
    y: 31.6,
    className: "st1",
    width: 437.1,
    height: 183.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "ea07d9fd-7a34-4098-acd7-056fd1871281",
    x: 309.3,
    className: "st2",
    width: 463.6,
    height: 19.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "b9ed5a45-8896-4ed9-86b4-15f853c9a185",
    className: "st1",
    cx: 323.9,
    cy: 11.6,
    r: 3.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "a9233a38-f8ba-48e0-88f3-496fd4836d40",
    className: "st1",
    cx: 337.8,
    cy: 11.6,
    r: 3.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "aa82180f-a6a9-4f5f-82fc-e73106f4ad92",
    className: "st1",
    cx: 351.6,
    cy: 11.6,
    r: 3.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 584.3,
    y: 61.3,
    className: "st3",
    width: 72.7,
    height: 124.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 425.6,
    y: 61.3,
    className: "st2",
    width: 146.6,
    height: 34.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 425.6,
    y: 105,
    className: "st3",
    width: 146.6,
    height: 36.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 425.6,
    y: 151.3,
    className: "st3",
    width: 146.6,
    height: 34.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M221.2,367.1c0.1-9.9-7.9-17.9-17.8-18c-0.7,0-1.4,0-2,0.1c-0.8,0.1-1.6,0.2-2.3,0.4l-60.5-51.8l3.6-19.5 l-29.8-9.7l-9,31.2c-2.2,7.7,0.9,15.9,7.7,20.2l74.4,47c0,0.6,0,1.2,0.1,1.8c1.1,9.8,9.9,16.9,19.7,15.8c0.7-0.1,1.3-0.2,2-0.3 c0.7-0.2,1.4-0.4,2.1-0.6C216.4,381.3,221.1,374.6,221.2,367.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M70.9,427.2h78c0,2.2,80.3,4.1,80.3,4.1c1.3,0.9,2.4,2,3.4,3.2c3.1,3.6,4.7,8.2,4.7,13v3.2 c0,11.2-9.1,20.3-20.3,20.3H70.9c-11.2,0-20.3-9.1-20.3-20.3v-3.2C50.6,436.3,59.7,427.2,70.9,427.2z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 134.6,
    y: 470.2,
    className: "st5",
    width: 21.1,
    height: 136.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M215.8,608.3c0,2.6-32,1-71.4,1s-71.4,1.6-71.4-1s32-22.8,71.4-22.8S215.8,605.8,215.8,608.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "196.7,589.9 216.6,589.9 226.1,538.3 196.7,538.3 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M191.6,609.2l64.2,0v-0.8c0-13.8-11.2-25-25-25h0h0l-39.2,0L191.6,609.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M226.5,557.9l39.7-89c6.9-15.6,0.6-33.8-14.3-41.9l-86.1-46.2l-39.3-3.3l-36.2-3.3l-0.3,0.4 c-0.3,0.6-8.1,14-2.9,28.8c4,11.2,14.4,19.9,30.9,26c38.5,14.1,83,26.2,100.3,30.7c1.5,0.4,2.9,1.4,3.6,2.9c0.7,1.4,0.9,3.1,0.3,4.5 l-36.9,82.8c-1.4,3.8,0.6,8,4.3,9.4c0.6,0.2,1.2,0.4,1.8,0.4l27.6,2c0.2,0,0.5,0,0.7,0C222.7,562.2,225.3,560.5,226.5,557.9z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "183.7,589.9 203.6,589.9 213.1,538.3 183.7,538.3 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M178.6,609.2l64.2,0v-0.8c0-13.8-11.2-25-25-25c0,0,0,0,0,0h0l-39.2,0L178.6,609.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M211.9,562.8l39.7-89c6.9-15.6,0.6-33.8-14.3-41.9l-86.1-46.2l-39.3-3.3l-28.4-2.5l0-0.4 c-0.3,0.6-8.1,14-2.9,28.8c4,11.2,6.3,19.9,22.8,26c38.5,14.1,83,26.2,100.3,30.7c1.5,0.4,2.9,1.4,3.6,2.9c0.7,1.4,0.9,3.1,0.3,4.5 l-36.9,82.8c-1.4,3.8,0.6,8,4.3,9.4c0.6,0.2,1.2,0.4,1.8,0.4l27.6,2c0.2,0,0.5,0,0.7,0C208.1,567.1,210.7,565.4,211.9,562.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M137.1,381.6c1.9-1.3,29.2,13,34.1,1.6c-22.7-56.8-7.1-81.4-21-114c-5-11.4-14.9-19.9-26.9-23l-36.1-1.8 l-0.2,0.1c-16.7,8.2-26.1,26.4-23.1,44.8c0.1,35.5,21.4,62.5,13.9,88.2c-0.6,2.2-0.3,4.5,0.8,6.5c1.1,1.9,2.9,3.3,5.1,3.7l47.7-6.4 c2.3,0.5,4.6,0.1,6.5-1.3L137.1,381.6z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 99.2,
    cy: 191,
    r: 39.9
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M86.5,227.6c2.1,0.9,6.5-16,4.5-19.3c-2.9-5-2.7-5-4.6-8.3s-2.3-7.9,0.1-10.8s8.2-2.5,9.4,1.1 c-0.7-7,6.2-12.6,13-14.1s14-0.6,20.9-2c8-1.6,16.2-8.3,13.1-17.1c-0.5-1.5-1.4-2.8-2.4-4c-3.7-4.1-8.8-5.9-13.8-7.6 c-10.4-3.5-21.2-7.1-32.2-6.7c-18.1,0.6-35.2,13.2-41.3,30.2c-0.8,2.1-1.3,4.3-1.8,6.5c-3.8,20.3,8,40.4,27.2,48.1L86.5,227.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M295.7,291.7l4.6,27.2c0.1,0.3,0,0.6-0.1,0.9l-35.9,89.7c-0.3,0.9-1.3,1.3-2.2,0.9c-0.6-0.2-1-0.8-1-1.5 l-1.5-36c0-0.2,0-0.5,0.1-0.7l32.8-80.8c0.3-0.9,1.3-1.3,2.2-0.9C295.2,290.7,295.6,291.2,295.7,291.7L295.7,291.7z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "293.1,293.8 297.5,317.2 265.6,399 261.5,372.6 "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M153.8,409c0.8,3.1,103.6,6.4,104.7,5.4c1-1.2,1.8-2.5,2.5-3.8c1.1-1.9,2.1-3.9,2.1-3.9l-1.7-32.5L160,363.4 c0,0-4.5,27.1-5.9,39.6C153.8,405,153.7,407,153.8,409z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "248.1,377.7 248.1,405.7 203.3,402.5 205.3,374.7 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "189.7,382.6 190,382.5 187.9,394.4 163,392.7 163.8,380.7 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M153.8,409c0.8,3.1,103.6,6.4,104.7,5.4c1-1.2,1.8-2.5,2.5-3.8L154.2,403C153.8,405,153.7,407,153.8,409z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.5,360.5l86.8,16.2c0.2,0.5,0.5,1.1,0.7,1.6c2.4,4.5,6.6,7.7,11.5,9c5,1.2,10.2,0.3,14.4-2.6 c8.1-5.6,10.2-16.7,4.6-24.8c-5.1-7.5-15.1-9.9-23.1-5.7c-0.7,0.4-1.4,0.8-2,1.3L130,329.6l-3.9-19.4l-31.3,2.1l3.2,32.6 C99,352.6,104.8,359,112.5,360.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,326.8l45.4-14.9l-10.6-30.4c-2.9-8.3-11.4-13.4-20.1-11.9l0,0c-8.8,1.5-15.3,9.1-15.2,18.1L93.9,326.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M382,610.8H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h381c0.6,0,1,0.4,1,1S382.6,610.8,382,610.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.0f1a0f68d5193a4aa6b435d96726dc6e.svg";
export { ForwardRef as ReactComponent };